import useSWR, { type SWRConfiguration } from "swr";
import { apiClient } from "@/lib/api/client";
import { apiPaths } from "@/lib/api/paths";
import type { Collar } from "@typings/entities/devices/collar";

async function getCollarById(id: string): Promise<Collar> {
  const response = await apiClient.get<Collar>(
    apiPaths.devices.collars.getById(id),
  );
  return response.data;
}

export function useGetCollarById(
  collarId: string | null,
  options?: SWRConfiguration,
) {
  return useSWR(
    collarId ? [`fetch-collar-${collarId}`] : null,
    () => getCollarById(collarId!),
    options,
  );
}
